/* LUNEXUS Warm – Video-Steuerung für snippets/lx-video-media.liquid (Doku: media/VIDEO-PLAN.md)
   - Quellen werden erst gesetzt, wenn erlaubt: Sichtbarkeit (IntersectionObserver), Breakpoint,
     prefers-reduced-motion, Save-Data / langsames Netz.
   - Ambient: stumm + Schleife; pausiert außerhalb des Viewports; Pause-Knopf (WCAG 2.2.2), Wahl bleibt erhalten.
   - Player: lädt erst nach Klick, dann native Bedienelemente. */
(function () {
  if (window.__lxv) return;
  window.__lxv = 1;

  var mqDesk = window.matchMedia('(min-width: 990px)');
  var mqTab = window.matchMedia('(min-width: 750px)');
  var mqRM = window.matchMedia('(prefers-reduced-motion: reduce)');
  var conn = navigator.connection || {};
  var saveData = !!conn.saveData || /(^|-)2g$|3g/.test(conn.effectiveType || '');

  function pick(el) {
    var big = mqTab.matches && !saveData;
    return (big ? el.dataset.hd : el.dataset.sd) || el.dataset.hd || el.dataset.sd;
  }
  function load(el, v) {
    if (v.dataset.loaded) return;
    v.dataset.loaded = '1';
    v.src = pick(el);
    if (el.hasAttribute('data-eager')) v.preload = 'metadata';
  }
  function showPoster(el) {
    var img = el.querySelector('img.lxv-poster[data-src]');
    if (img && !img.getAttribute('src')) img.src = img.dataset.src;
  }
  function setBtn(el, playing) {
    var b = el.querySelector('.lxv-toggle');
    if (!b) return;
    b.hidden = false;
    b.setAttribute('aria-label', playing ? el.dataset.tPause : el.dataset.tPlay);
    el.classList.toggle('is-paused', !playing);
  }
  function play(el, v) {
    load(el, v);
    var p = v.play();
    if (p && p.catch) p.catch(function () { setBtn(el, false); });
  }

  function initAmbient(el) {
    var v = el.querySelector('video');
    var donly = el.hasAttribute('data-donly');
    var mobile = el.dataset.mobile || 'poster_tap';
    var userPaused = false;
    var userStarted = false;
    var inView = false;

    v.addEventListener('playing', function () { el.classList.add('is-playing'); setBtn(el, true); });
    v.addEventListener('pause', function () { setBtn(el, false); });

    function autoAllowed() {
      if (mqRM.matches || saveData) return false;
      if (donly) return mqDesk.matches;
      if (mqTab.matches) return true;
      return mobile === 'autoplay';
    }
    function tapAllowed() {
      if (donly) return mqDesk.matches;
      if (mqTab.matches) return true;
      return mobile !== 'poster';
    }

    var btn = el.querySelector('.lxv-toggle');
    if (btn) {
      btn.addEventListener('click', function () {
        if (v.paused) { userPaused = false; userStarted = true; play(el, v); }
        else { userPaused = true; v.pause(); }
      });
    }

    function sync() {
      if (donly && !mqDesk.matches) { if (!v.paused) v.pause(); return; }
      if (donly) showPoster(el);
      if (!inView) { if (!v.paused) v.pause(); return; }
      if (userPaused) return;
      if (autoAllowed() || userStarted) play(el, v);
      else if (tapAllowed()) setBtn(el, false);
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { inView = e.isIntersecting; sync(); });
      }, { rootMargin: '200px 0px' }).observe(el);
    } else { inView = true; sync(); }
    [mqDesk, mqTab, mqRM].forEach(function (m) {
      if (m.addEventListener) m.addEventListener('change', sync);
    });
  }

  function initPlayer(el) {
    var v = el.querySelector('video');
    var b = el.querySelector('.lxv-start');
    if (!b) return;
    b.addEventListener('click', function () {
      v.controls = true;
      el.classList.add('is-started');
      b.hidden = true;
      play(el, v);
      v.focus();
    });
    v.addEventListener('playing', function () { el.classList.add('is-playing'); });
  }

  function init() {
    document.querySelectorAll('[data-lxv]:not([data-lxv-ready])').forEach(function (el) {
      el.setAttribute('data-lxv-ready', '');
      if (el.dataset.mode === 'player') initPlayer(el); else initAmbient(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
